import { FormItem } from '../../../../../commons/Form/Form.types';
import { RegisterSignUpStepFormSchema } from './RegisterSignUpStepForm.types';

export const registerSignUpStepData: FormItem<RegisterSignUpStepFormSchema>[][] = [
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'password',
      placeholder: 'Votre mot de passe...',
      label: 'Mot de passe',
      type: 'password',
      required: true,
    },
    {
      name: 'passwordConfirmation',
      placeholder: 'Confirmez votre mot de passe...',
      label: 'Confirmation du mot de passe',
      type: 'password',
      required: true,
    },
  ],
];
